import { render, staticRenderFns } from "./EmailValidationForm.vue?vue&type=template&id=c0d7f540&"
import script from "./EmailValidationForm.vue?vue&type=script&lang=js&"
export * from "./EmailValidationForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailValidationForm.vue?vue&type=style&index=0&id=c0d7f540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports